export enum IResponseTypes {
  success = 0,
  alert = 1,
  error = 2
}

export interface IPaginatedEntityGST<T> extends IGenericResponseGST {
  entity: {
    items: T
    pageCount: number
    totalItemCount: number
    pageNumber: number
    pageSize: number
    hasPreviousPage: boolean
    hasNextPage: boolean
    isFirstPage: boolean
    firstItemOnPage: number
    lastItemOnPage: number
  }
}

export interface IEntityGST<T> extends IGenericResponseGST {
  entity: T
}

export interface IGenericResponseGST {
  mensagem: string
  detalhe: string
  tipo: IResponseTypes
}
